<template>
    <!-- Un segmento de "Qué perfil reserva más": barra = % de los intakes de
         ese grupo que terminó con una reserva confirmada. Mismo orden que
         manda la API (de más a menos intakes). Cada fila tiene un tooltip con
         la cuenta (mouse o teclado). -->
    <div class="es-cv-g">
        <h4>{{ titulo }}</h4>
        <div v-if="items.length" class="es-bars" role="list">
            <div v-for="(x, i) in items" :key="x.t" class="es-bar es-cv" :class="{ 'is-max': x.pct > 0 && x.pct === max }"
                 role="listitem" tabindex="0" :aria-label="texto(x)"
                 @mouseenter="sobre = i" @mouseleave="sobre = null" @focus="sobre = i" @blur="sobre = null">
                <span class="es-bar-track" aria-hidden="true"><span class="es-bar-fill" :style="{ width: ancho(x) }"></span></span>
                <span class="es-bar-t" aria-hidden="true">{{ x.t }}</span>
                <span class="es-bar-n es-cv-n" aria-hidden="true"><span class="es-cv-xy"><b>{{ cifra(x.reservados) }}</b> de <b>{{ cifra(x.intakes) }}</b></span><small>{{ fmtPct(x.pct) }}</small></span>
                <span v-if="sobre === i" class="es-cv-tip" :class="{ 'is-abajo': i < 2 }" role="tooltip">
                    <b>{{ x.t }}</b>
                    {{ cifra(x.intakes) }} {{ x.intakes === 1 ? 'intake' : 'intakes' }} en el período ·
                    {{ cifra(x.reservados) }} {{ x.reservados === 1 ? 'tiene' : 'tienen' }} una reserva confirmada.<br>
                    → Reservó el <b class="es-cv-tip-p">{{ fmtPct(x.pct) }}</b> de este grupo (promedio general {{ fmtPct(promedio) }}).
                    <em v-if="x.intakes < 30">Son pocos intakes: el % puede cambiar mucho con una sola reserva.</em>
                </span>
            </div>
        </div>
        <p v-else class="es-vacio">Sin datos.</p>
    </div>
</template>

<script>
export default {
    name: 'EstConversion',
    props: {
        titulo: { type: String, required: true },
        items: { type: Array, default: () => [] },
        promedio: { type: Number, default: 0 },
    },
    data() { return { sobre: null }; },
    computed: { max() { return Math.max(0, ...this.items.map(x => x.pct)); } },
    methods: {
        cifra(n) { return Number(n || 0).toLocaleString('es-CL'); },
        fmtPct(p) { return Number(p || 0).toLocaleString('es-CL', { maximumFractionDigits: 1 }) + '%'; },
        // La barra se mide contra el mayor % del grupo para que se vean las diferencias.
        ancho(x) { return this.max && x.pct ? Math.max(2, Math.round(x.pct * 100 / this.max)) + '%' : '0%'; },
        texto(x) { return `${x.t}: ${this.cifra(x.reservados)} de ${this.cifra(x.intakes)} intakes reservaron (${this.fmtPct(x.pct)}). Promedio general ${this.fmtPct(this.promedio)}.`; },
    },
};
</script>
